export const ZONE0 = {
  data () {
    return {
      dataInfo: []
    }
  },
  mounted () {
    this.dataInfo = [{
      isEdit: true,
      id: 0,
      zone: {
        value: '0'
      },
      descr: {
        value: 'All Zones',
        type: 'input',
        disabled: true,
        maxlength: 32,
        change: (data, rowData, index) => {
          const value = data.value
          if (value.length > 32) {
            this.$message.error(this.$t('tooLong'))
            data.value = value.substr(0, 32)
          }
          this.addDataToArr(rowData, index)
        }
      },
      sndDelay: {
        value: '0',
        type: 'input',
        width: 80,
        change: (data, rowData, index) => {
          const value = +data.value
          if (value < 0 || value > 600 || isNaN(value)) {
            this.$message.error(this.$t('outOfRange'))
            data.value = 1
          }
          this.addDataToArr(rowData, index, 'sndDelay')
        },
        // btn: (rowData, index) => {
        //   this.clickBtn(rowData, index)
        // }
      },
      frDelay: {
        value: '-'
      },
      sndDelaytoDET: {
        value: '-'
      },
      sndDelaytoMCP: {
        value: '-'
      },
      frDelaytoDET: {
        value: '-'
      },
      frDelaytoMCP: {
        value: '-'
      },
      linkSndtoDET: {
        value: this.$t('yes'),
        type: 'select',
        width: 80,
        options: this.yesOrNo,
        change: (data, rowData, index) => {
          this.addDataToArr(rowData, index, 'linkSndtoDET')
        },
        // btn: (rowData, index) => {
        //   this.clickBtn(rowData, index)
        // }
      },
      linkSndtoMCP: {
        value: this.$t('yes'),
        type: 'select',
        width: 80,
        options: this.yesOrNo,
        change: (data, rowData, index) => {
          this.addDataToArr(rowData, index, 'linkSndtoMCP')
        },
        // btn: (rowData, index) => {
        //   this.clickBtn(rowData, index)
        // }
      },
      linkFrtoDET: {
        value: '-'
      },
      linkFrtoMCP: {
        value: '-'
      }
    }]
  }
}
